import { useState } from "react";
import { HexColorPicker } from "react-colorful";
import { useTranslation } from "react-i18next";

import Modal, { ModalButton } from "../../../../../../../components/Modal";
import InputColor from "../../PreDefinedColorSection/components/InputColor";
import { ColorField, ColorPicker } from "./styles";

type Props = {
  onExit: () => void;
  onSave: (color: string) => void;
  color: string;
};

/** Picks a custom color: the picker edge to edge, and the hex field with Save at the bottom */
export const SelectColorModal = ({ onExit, onSave, color }: Props) => {
  const { t } = useTranslation();
  const [internalColor, setInternalColor] = useState(color);

  return (
    <Modal
      size="sm"
      flush
      title={t("pages.editor.settings.modal.selectColor.title")}
      onExit={onExit}
      footer={
        <>
          <ColorField>
            <InputColor color={internalColor} onChange={setInternalColor} />
          </ColorField>
          <ModalButton onClick={() => onSave(internalColor)}>{t("actions.save")}</ModalButton>
        </>
      }>
      <ColorPicker>
        <HexColorPicker color={internalColor} onChange={setInternalColor} />
      </ColorPicker>
    </Modal>
  );
};
